import { FC, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, useLibrary } from 'yolda-web-ui'

import TenantService from '../../../services/TenantService'
import { StyledRemoveRoute } from './RemoveRoute.stye'

type RemoveRoute = {
  reqBody: unknown
  onClose: () => void
}

const RemoveRoute: FC<RemoveRoute> = ({ reqBody, onClose }) => {
  const { t } = useTranslation()
  const { init } = useLibrary()

  const { data: tenant, mutate: mutateTenant } = TenantService.getCurrentTenant(false, false)
  const { data: response, isValidating, mutate } = TenantService.updateFavRoute(reqBody)

  useEffect(() => {
    if (response?.status === 'success') {
      mutateTenant()
      onClose()
      mutate(undefined, { revalidate: false })

      init('success', 'toast', {
        title: t('favoriteroutes.removeSuccessMessage'),
      })
    }
  }, [response])

  return (
    <StyledRemoveRoute>
      <p>{t('favoriteroutes.removeModal.desc')}</p>
      <section>
        <Button variant="outline">{t('modal.favoriteroutes.exit.giveUp')}</Button>
        <Button
          disabled={isValidating}
          loading={isValidating}
          onClick={() => {
            mutate()
          }}
        >
          {t('modal.favoriteroutes.delete.deleteRoute')}
        </Button>
      </section>
    </StyledRemoveRoute>
  )
}

export default RemoveRoute
